// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"237":"job-offers-details","719":"unsubscribe","976":"job-offers"}[chunkId] + "." + {"237":"913d376f","719":"f7d0d375","976":"57697aec"}[chunkId] + ".css";
};